<template>

<kt-modal
    :visible="recordVisible"
    :title="recordTitle"
    :size="'modal-xl'"
    @dismiss="onDismiss()"
>
    <template #body>
        <time-form v-model="record"></time-form>
    </template>

    <template #footer>
        <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
    </template>
</kt-modal>
    
</template>

<script lang="ts" setup>

import { ref, watch, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Api from "@/services/Api";

import ApiService from "@/services/ApiService";
import Emitter from "@/services/Emitter";
import { TimeModel } from "@/models/TaskModel";

import Cache from "@/services/Cache";
import Helper, { DateFormat } from "@/services/Helper";
import Alert from "@/services/Alert";
import TimeForm from "@/components/Time/TimeForm.vue";
import KtModal from "@/components/UI/KtModal.vue";


const props = defineProps(
    {
        type: {
            type: String,
            default: "work"
        }
    }
);

const unwatch:Array<Function> = [];

const route = useRoute();
const router = useRouter();
const recordTitle = ref("Time Entry");
const recordVisible = ref(true);

const newRecord = ():TimeModel =>
{
    return new TimeModel();

    /*
    return {
        AssignedTo: "",
        WorkAssignment: "",
        EstimatedTime: "",
        CompleteByDate: "",
        TimeHoursWork: "",
        TimeTaskLocation: "",
        ActualWork: "",
        ActualTime: "",
        ActualOvertime: "",
        ShouldBill: "",
        WorkCompleteDate: "",
        TaskLocation: "",
        InvoiceText: "",
        InvoiceAmount: "",
        Status: "",
        PaidAmount: "",
        RequestId: "",
        ClientId: ""
    };
    */
};

const record = ref(newRecord());

const saveRecord = async () =>
{
    let data = Helper.prep(record.value);

    //... TODO - perform validation here

    console.debug("save", data);

    data = await ApiService.saveTime(data);

    Emitter.emit("redirect", "/time/edit/" + data.Id);
};

const deleteRecord = async () =>
{
    Alert.notify("Deletion is currently disabled");
};


const onDismiss = () =>
{
    let type = "work";

    if (props.type)
    {
        type = props.type;
    }

    // update to go back instead ...
    Emitter.emit("redirect", "/time/list/type=" + type);
};

const loadRecord = async (val:string) =>
{
    /*
    let filter = Cache.get("time-filter");
    filter = Helper.fromUrlParams(filter);
    */

    let filter = Cache.get(props.type + "-filter");
    filter = Helper.fromUrlParams(filter) || {};

    console.debug("time filter", filter);

    switch (val)
    {
        case "new":
            let tmp = newRecord();
            
            if (filter.type)
            {
                tmp.Type = filter.type || "work";
            }
            
            if (tmp.Type == "work")
            {
                recordTitle.value = "New Time Entry";
            }
            
            else {
                recordTitle.value = "New Tech Task";
            }
            
            record.value = tmp; 
            break;

        default:
            let rec = await ApiService.loadTime(val);

            if (filter.type)
            {
                rec.Type = filter.type || "work";
            }

            else
            {
                // check if a "work" or "task" based on fields populated...
                let val = "work";
                if (
                    (rec.WorkAssignment || rec.EstimatedTime || rec.CompleteByDate)
                    && 
                    (!rec.Status && !rec.ActualWork && !rec.InvoiceText)
                ) {
                    val = "task";
                }

                rec.Type = val;
            }


            if (rec.Type == "work")
            {
                recordTitle.value = "Edit Time Entry";
            }

            else {
                recordTitle.value = "Edit Tech Task";
            }
            
            /* - being done in the API now ...
            rec.ClientId = rec.Request?.Customer;

            if (rec.TaskLocation)
            {
                rec.TaskLocation = Number(rec.TaskLocation);
            } else {
                rec.TaskLocation = "";
            }

            if (rec.Status)
            {
                rec.Status = Number(rec.Status);
            }
            else {
                rec.Status = "";
            }

            if (rec.CompleteByDate) {
                // rec.CompleteByDate = new Date(rec.CompleteByDate + "Z");
                // remove time component for now ...

                rec.CompleteByDate = new Date(rec.CompleteByDate.split("T")[0] + " 00:00:00");
                rec.CompleteByDate = Helper.dateToInput(rec.CompleteByDate, "date");
            }

            if (rec.WorkCompleteDate) {
                // rec.WorkCompleteDate = new Date(rec.WorkCompleteDate + "Z");
                // remove time component for now ...
                rec.WorkCompleteDate = new Date(rec.WorkCompleteDate.split("T")[0] + " 00:00:00");
                rec.WorkCompleteDate = Helper.dateToInput(rec.WorkCompleteDate, "date");
            }
            */

            record.value = rec;
            break;
    }
}


unwatch.push(watch(() => [route.params.id, route.name] as const, async ([id, name]) =>
{
    // Handle both new and edit routes
    if (!id && name === "Time New") {
        loadRecord("new");
    } else if (id) {
        loadRecord(id + "");
    }
},
{
    immediate: true
}));

onUnmounted(() =>
{
    unwatch.forEach((un) =>
    {
        un();
    });
});

</script>